import { PlatformService } from '../../platform/platform.service';
import { ResponseWorkflowOfflineAndroidDao } from './response-workflow-offline-android.dao';
import { ResponseWorkflowOfflineWebDao } from './response-workflow-offline-web.dao';
import { ResponseWorkflowOfflineDao } from './response-workflow-offline.dao';

const ResponseWorkflowOfflineDaoFactory = (platformService: PlatformService) => platformService.isAndroidApp() ? 
    new ResponseWorkflowOfflineAndroidDao() : new ResponseWorkflowOfflineWebDao();

export const ResponseWorkflowOfflineDaoProvider = { 
    provide: ResponseWorkflowOfflineDao,
    useFactory: ResponseWorkflowOfflineDaoFactory,
    deps: [PlatformService]
};